// frontend/admin-portal/src/components/suppliers/SupplierStats.jsx
import React, { useEffect, useState } from "react";
import { Card, Title, Spinner } from "@fiberhome/shared-ui";
import { supplierService } from "../../services/supplierService";

export default function SupplierStats({ refreshKey = 0 }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    supplierService
      .stats()
      .then((s) => alive && setStats(s))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [refreshKey]);

  const cards = [
    { label: "Total Suppliers", value: stats?.total ?? "—" },
    { label: "Active", value: stats?.active ?? "—" },
    { label: "Inactive", value: stats?.inactive ?? "—" },
    { label: "With Linked Products", value: stats?.withProducts ?? "—" },
  ];

  return (
    <div className="row g-3 mb-4">
      {cards.map((c) => (
        <div className="col-md-3 col-sm-6" key={c.label}>
          <Card hoverable>
            <div className="text-muted" style={{ fontSize: 12 }}>
              {c.label}
            </div>
            <Title level={2} className="mb-0">
              {loading ? <Spinner size="md" /> : c.value}
            </Title>
          </Card>
        </div>
      ))}
    </div>
  );
}
